import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import isolatedScroll from './isolatedScroll';

const IsolatedScroll = ({ children }) => {
  const componentRef = useRef(null);
  const unbindHandlersRef = useRef(null);

  useEffect(() => {
    unbindHandlersRef.current = isolatedScroll(componentRef.current);
    return () => {
      unbindHandlersRef.current();
    };
  }, []);

  return <div ref={componentRef}>{children}</div>;
};

IsolatedScroll.propTypes = {
  children: PropTypes.node.isRequired,
};

export default IsolatedScroll;
